import React, { useRef, useState } from 'react';
import homefeaturedData from '../data/homefeatureddata';

// Provide a default placeholder image used when a listing has no image
const defaultPlaceholder = '/defaultimages/imagenotavailable.jpg';

// Fallback demo data (used only if no `featuredListings` prop is provided)

const HomeFeaturedListings = ({ featuredListings = [] }) => {
  const rawList = (featuredListings && featuredListings.length > 0)
    ? featuredListings
    : (Array.isArray(homefeaturedData) && homefeaturedData.length > 0)
      ? homefeaturedData.filter(h => h.featuredListings)
      : homefeaturedData;

  // Sort by `listingorder` ascending; fallback to `dateposted` (newer first)
  const list = Array.from(rawList).sort((a, b) => {
    const la = (a && a.listingorder) ? Number(a.listingorder) : 999999;
    const lb = (b && b.listingorder) ? Number(b.listingorder) : 999999;
    if (la !== lb) return la - lb;
    const da = a && a.dateposted ? new Date(a.dateposted).getTime() : 0;
    const db = b && b.dateposted ? new Date(b.dateposted).getTime() : 0;
    return db - da;
  });
  const scrollRef = useRef(null);
  const [modalItem, setModalItem] = useState(null);

  const scrollBy = (delta) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: delta, behavior: 'smooth' });
    }
  };

  const [showShareMenu, setShowShareMenu] = useState(false);

  const copyToClipboard = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).catch(() => {});
    } else {
      try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (e) {}
    }
  };

  return (
    <div style={{ marginBottom: '1rem', position: 'relative' }}>

      {/* Left Arrow Button */}
      <button
        aria-label="Scroll featured left"
        onClick={() => scrollBy(-200)}
        style={{
          position: 'absolute',
          top: '35%',
          transform: 'translateY(-50%)',
          left: 0,
          zIndex: 2,
          background: '#fff',
          color: '#1976d2',
          border: '2px solid #1976d2',
          borderRadius: '50%',
          width: 28,
          height: 28,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
          fontSize: 18,
          transition: 'background 0.2s, color 0.2s, border 0.2s'
        }}
        onMouseOver={e => {
          e.currentTarget.style.background = '#1976d2';
          e.currentTarget.style.color = '#fff';
          e.currentTarget.style.border = '2px solid #fff';
        }}
        onMouseOut={e => {
          e.currentTarget.style.background = '#fff';
          e.currentTarget.style.color = '#1976d2';
          e.currentTarget.style.border = '2px solid #1976d2';
        }}
      >
        <span className="material-icons" style={{ fontSize: 18, lineHeight: 1 }}>chevron_left</span>
      </button>

      {/* Right Arrow Button */}
      <button
        aria-label="Scroll featured right"
        onClick={() => scrollBy(200)}
        style={{
          position: 'absolute',
          top: '35%',
          transform: 'translateY(-50%)',
          right: 0,
          zIndex: 2,
          background: '#fff',
          color: '#1976d2',
          border: '2px solid #1976d2',
          borderRadius: '50%',
          width: 28,
          height: 28,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
          fontSize: 18,
          transition: 'background 0.2s, color 0.2s, border 0.2s'
        }}
        onMouseOver={e => {
          e.currentTarget.style.background = '#1976d2';
          e.currentTarget.style.color = '#fff';
          e.currentTarget.style.border = '2px solid #fff';
        }}
        onMouseOut={e => {
          e.currentTarget.style.background = '#fff';
          e.currentTarget.style.color = '#1976d2';
          e.currentTarget.style.border = '2px solid #1976d2';
        }}
      >
        <span className="material-icons" style={{ fontSize: 12, width: 14, height: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 }}>chevron_right</span>
      </button>

      {/* Scroll Container */}
      <div
        ref={scrollRef}
        className="hide-scrollbar"
        style={{
          display: 'flex',
          gap: 0,
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          padding: '4px 40px',
          scrollSnapType: 'x mandatory',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none'
        }}
      >
        {list.map((item, idx) => (
            <div
              key={item.id || idx}
              onClick={() => setModalItem(item)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setModalItem(item); } }}
              tabIndex={0}
              role="button"
              style={{
                minWidth: 117.0,
                maxWidth: 130.0,
                width: 147,
                height: 157,
                border: '1px solid #e0e0e0',
                borderRadius: 8,
                padding: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                boxSizing: 'border-box',
                scrollSnapAlign: 'start',
                cursor: 'pointer'
              }}
          >
            <img
              src={item.imagepath || defaultPlaceholder}
              alt={item.title || item.businessname }
              style={{ width: '100%', maxWidth: 110, height: 75.0, objectFit: 'cover', borderRadius: 6, marginBottom: 4 }}
              onError={e => { e.target.onerror = null; e.target.src = defaultPlaceholder; }}
            />


            <h3 style={{ margin: '2px 0 4px 0', fontSize: 12, color: '#1976d2', textAlign: 'left' }}>
                  { (item.businessname && item.businessname.length > 25
                    ? item.businessname.slice(0, 25) + '...'
                    : item.businessname)}
            </h3>

            {/* Location (locationname + areaname) */}
            { (item.locationname || item.areaname) && (
              <div style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>
                {item.locationname || ''}{item.areaname ? ` • ${item.areaname}` : ''}
              </div>
            )}
            {/* About description intentionally hidden on home cards; shown only in modal */}
          </div>
        ))}
      </div>

      {/* Detail Modal */}
      {modalItem && (
        <div
          onClick={() => setModalItem(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            padding: 20
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff',
              borderRadius: 16,
              width: 'min(calc(100vw - 24px), 680px)',
              maxWidth: '98vw',
              maxHeight: '90vh',
              overflowY: 'auto',
              position: 'relative',
            }}
          >
            <button
              onClick={() => setModalItem(null)}
              style={{
                position: 'absolute',
                top: 5,
                right: 5,
                background: '#fff',
                color: '#d32f2f',
                border: '2px solid #d32f2f',
                borderRadius: '50%',
                width: 30,
                height: 30,
                cursor: 'pointer',
                fontSize: 28,
                fontWeight: 'bold',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
                transition: 'background 0.2s, color 0.2s, border 0.2s'
              }}
              aria-label="Close"
              onMouseOver={e => {
                e.currentTarget.style.background = '#d32f2f';
                e.currentTarget.style.color = '#fff';
                e.currentTarget.style.border = '2px solid #fff';
              }}
              onMouseOut={e => {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.color = '#d32f2f';
                e.currentTarget.style.border = '2px solid #d32f2f';
              }}
            >
              ×
            </button>

            {/* Main Image */}
            <img
              src={modalItem.imagepath || defaultPlaceholder}
              alt={modalItem.businessname || modalItem.title}
              style={{ width: '94%', maxWidth: 400, height: 350, objectFit: 'cover', objectPosition: 'top center', borderRadius: 12, display: 'block', margin: '12px auto 0 auto' }}
              onError={(e) => { e.target.onerror = null; e.target.src = defaultPlaceholder; }}
            />

            {/* Display multiple images below the main image */}
            {modalItem.photos && modalItem.photos.length > 0 && (
              <div style={{ position: 'relative', marginTop: 10 }}>
                <button
                  onClick={() => {
                    const container = document.getElementById('photo-scroll-container');
                    if (container) container.scrollBy({ left: -100, behavior: 'smooth' });
                  }}
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(0, 0, 0, 0.5)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '50%',
                    width: 20,
                    height: 20,
                    cursor: 'pointer',
                    zIndex: 2,
                    fontSize: 16
                  }}
                  aria-label="Scroll left"
                >
                  ‹
                </button>

                <div
                  id="photo-scroll-container"
                  style={{ display: 'flex', gap: 10, overflowX: 'auto', scrollBehavior: 'smooth', padding: '0 40px' }}
                >
                  {modalItem.photos.map((photo, index) => (
                    <img
                      key={index}
                      src={photo || defaultPlaceholder}
                      alt={`Featured ${index + 1}`}
                      style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 8, cursor: 'pointer' }}
                      onClick={() => setModalItem({ ...modalItem, imagepath: photo })}
                      onError={(e) => { e.target.onerror = null; e.target.src = defaultPlaceholder; }}
                    />
                  ))}
                </div>

                <button
                  onClick={() => {
                    const container = document.getElementById('photo-scroll-container');
                    if (container) container.scrollBy({ left: 100, behavior: 'smooth' });
                  }}
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(0, 0, 0, 0.5)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '50%',
                    width: 22,
                    height: 22,
                    cursor: 'pointer',
                    zIndex: 2,
                    fontSize: 16
                  }}
                  aria-label="Scroll right"
                >
                  ›
                </button>
              </div>
            )}

            <div style={{ padding: '8px 20px 20px 20px' }}>
              {modalItem.featuredListings && (
                <div style={{ fontSize: 11, color: '#fff', background: '#388e3c', padding: '4px 10px', borderRadius: 4, display: 'inline-block', marginBottom: 6, fontWeight: 600 }}>
                  Featured
                </div>
              )}

              <h2 style={{ margin: '0 0 2px 0', fontSize: 18, color: '#1976d2' }}>{modalItem.title || modalItem.businessname}</h2>
              {modalItem.businesstype && (
                <div style={{ fontSize: 14, color: '#888', margin: '0 0 4px 0', fontWeight: 700 }}>{modalItem.businesstype}</div>
              )}
              <div style={{ fontSize: 14, color: '#888', marginBottom: 10, fontWeight: 600 }}>
                📍 {modalItem.locationname || ''}{(modalItem.areaname || modalItem.areaname) ? ` • ${modalItem.areaname || modalItem.areaName}` : ''}
              </div>             
             
             <div style={{ fontSize: 13, fontWeight: 700, color: '#555', marginTop: 4, lineHeight: 1.4 , marginBottom: 6 }}>
                      Description: <span style={{ fontWeight: 400, color: '#555' }}>{modalItem.aboutdescription}</span>
              </div>
              {(modalItem.contactnumber || modalItem.contactperson) && (
                <div style={{ marginBottom: 6 }}>
                  <strong style={{ fontSize: 15, color: '#333' }}>Contact Details:</strong>
                  {modalItem.contactperson && (
                    <div style={{ fontSize: 13, fontWeight: 800, color: '#666', marginTop: 4 }}>
                      Name: <span style={{ fontWeight: 400, color: '#555' }}>{modalItem.contactperson}</span>
                    </div>
                  )}
                  {modalItem.contactnumber && (
                    <a
                      href={`tel:${(modalItem.contactnumber || '').replace(/\s/g, '')}`}
                      style={{
                        fontSize: 13,
                        color: '#d32f2f',
                        marginTop: 4,
                        fontWeight: 600,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                    >
                      📞 {modalItem.contactnumber}
                    </a>
                  )}

                    <div style={{ fontSize: 13, fontWeight: 800, color: '#666', marginTop: 4 }}>
                      Address: <span style={{ fontWeight: 400, color: '#555' }}>
                        {modalItem.address1}
                        {modalItem.address1 && (
                          <>
                            {' '}
                            <a
                              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(modalItem.address1)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1976d2', textDecoration: 'underline', marginLeft: 6, fontSize: 13 }}
                            >
                              [Map]
                            </a>
                          </>
                        )}
                      </span>
                    </div>
                    <div style={{ fontSize: 13, fontWeight: 800, color: '#666', marginTop: 4 }}>
                      Website: {modalItem.website ? (
                        <a
                          href={modalItem.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ fontWeight: 400, color: '#1976d2', textDecoration: 'underline', wordBreak: 'break-all' }}
                        >
                          {modalItem.website}
                        </a>
                      ) : (
                        <span style={{ fontWeight: 400, color: '#555' }}>{modalItem.website}</span>
                      )}
                    </div>
                </div>
                
              )}

              {/* Action buttons */}
              <div style={{ display: 'flex', gap: 12, marginTop: 12, marginBottom: 8, justifyContent: 'center' }}>
                {modalItem.contactnumber && (
                  <button
                    onClick={() => window.location.href = `tel:${(modalItem.contactnumber || '').replace(/\s/g, '')}`}
                    style={{
                      padding: '8px 16px',
                      background: '#4CAF50',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 5,
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    📞 Call
                  </button>
                )}

                <div style={{ position: 'relative' }}>
                  <button
                    onClick={() => setShowShareMenu(!showShareMenu)}
                    style={{
                      padding: '8px 16px',
                      background: '#1976d2',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 5,
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    🔗 Share
                  </button>

                  {showShareMenu && (
                    <div style={{
                      position: 'absolute',
                      bottom: '100%',
                      left: 0,
                      marginBottom: 8,
                      background: '#fff',
                      border: '1px solid #ddd',
                      borderRadius: 8,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      zIndex: 100,
                      overflow: 'hidden'
                    }}>
                      <button
                        onClick={() => { window.open(`https://wa.me/?text=${encodeURIComponent((modalItem.businessname||modalItem.title)+' '+(modalItem.website||window.location.href))}`); setShowShareMenu(false); }}
                        style={{ width: '100%', padding: '10px 16px', background: '#25D366', color: '#fff', border: 'none', fontWeight: 600 }}
                      >
                        WhatsApp
                      </button>
                      <button
                        onClick={() => { window.location.href = `mailto:?subject=${encodeURIComponent(modalItem.businessname||modalItem.title)}&body=${encodeURIComponent(modalItem.aboutdescription||'')}`; setShowShareMenu(false); }}
                        style={{ width: '100%', padding: '10px 16px', background: '#fff', color: '#333', border: 'none' }}
                      >
                        Email
                      </button>
                      <button
                        onClick={() => { copyToClipboard(modalItem.website || window.location.href); setShowShareMenu(false); }}
                        style={{ width: '100%', padding: '10px 16px', background: '#fff', color: '#333', border: 'none' }}
                      >
                        Copy Link
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Social links if any */}
              {(modalItem.sm_insta || modalItem.sm_facebook || modalItem.sm_youtube) && (
                <div style={{ marginTop: 6, paddingTop: 6, borderTop: '1px solid #e0e0e0' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <strong style={{ fontSize: 14, color: '#333' }}>Follow us:</strong>
                    <div style={{ display: 'flex', gap: 10 }}>
                      {modalItem.sm_insta && (<a href={modalItem.sm_insta} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#fff', background: 'linear-gradient(45deg,#f09433,#e6683c)', padding: 6, borderRadius: 6 }}>IG</a>)}
                      {modalItem.sm_facebook && (<a href={modalItem.sm_facebook} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#fff', background: '#1877F2', padding: 6, borderRadius: 6 }}>f</a>)}
                      {modalItem.sm_youtube && (<a href={modalItem.sm_youtube} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#fff', background: '#FF0000', padding: 6, borderRadius: 6 }}>▶</a>)}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <div style={{ height: 8 }} aria-hidden="true" />
    </div>
  );
};

export default HomeFeaturedListings;
